import { useNeoletterUserProfile } from "shared/api/neoletter-user-profile/useNeoletterUserProfile"
import { useAuth } from "shared/lib/useAuth"

import { useProjectPermissionsQuery } from "entities/projects/graphql/queries.generated"

/**
 * Warms the permissions of the active project so overlays that target it (such
 * as adding a product position from the product page) can render editable
 * immediately instead of waiting out a disabled state.
 */
export function useActiveProjectPermissionsPrefetch() {
  const { isAuthenticated } = useAuth()
  const { activeProjectID } = useNeoletterUserProfile()

  useProjectPermissionsQuery({
    variables: { projectID: activeProjectID as string },
    skip: !activeProjectID || !isAuthenticated
  })
}
